import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  getExploreBrotherDevicesLink,
  getNeedHelpLink,
  getRecycleForFreeWithBrotherLink
} from '../../../constants/AppMethod';
import { ReactComponent as ArrowIcon } from "../../../assets/images/mydevices/arrow.svg";
import { CREATIVE_CENTER_LINK } from '../../../constants/AppConstants';
import './CardComponent.css';

const CardComponent = ({ title, description}) => {
  return (
     <div class="my-devices-card-container">
      <div class="my-devices-card-content">
        <h3>{title}</h3>
        <p className='card-content-description'>{description}</p>
      </div>
      <div class="arrow"><ArrowIcon /></div>
    </div>
  )
};

const RecycleComponent = () => {
  const { t } = useTranslation(["translation"]);
  const recycleForFreeWithBrotherLink = getRecycleForFreeWithBrotherLink();

  return (
    <div className='explore-more-card-wrapper' style={{ backgroundColor: "#e8f5e9" || 'white' }}>
      <a
        href={recycleForFreeWithBrotherLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none', color: '#666' }}
      >
        <CardComponent
          title={t('MY_DEVICES.HEADER.RECYCLE_TITLE')}
          description={t('MY_DEVICES.HEADER.RECYCLE_DESCRIPTION')}
        />
      </a>
    </div>
  );
};

const InspireComponent = () => {
  const { t } = useTranslation(["translation"]);

  return (
    <div className='explore-more-card-wrapper' style={{ backgroundColor: "#fbe9e7" || 'white' }}>
      <a
        href={CREATIVE_CENTER_LINK}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none', color: '#666' }}
      >
        <CardComponent
          title={t('MY_DEVICES.HEADER.INSPIRE_TITLE')}
          description={t('MY_DEVICES.HEADER.INSPIRE_DESCRIPTION')}
        />
      </a>
    </div>
  );
};

const ExploreComponent = () => {
  const { t } = useTranslation(["translation"]);
  const exploreBrotherDevicesLink = getExploreBrotherDevicesLink();

  return (
    <div className='explore-more-card-wrapper' style={{ backgroundColor: "#ede7f6" || 'white' }}>
      <a
        href={exploreBrotherDevicesLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none', color: '#666' }}
      >
        <CardComponent
          title={t('MY_DEVICES.HEADER.EXPLORE_TITLE')}
          description={t('MY_DEVICES.HEADER.EXPLORE_DESCRIPTION')}
        />
      </a>
    </div>
  );
};

const NeedHelpComponent = () => {
  const { t } = useTranslation(["translation"]);
  const needHelpLink = getNeedHelpLink();

  return (
    <div className='explore-more-card-wrapper' style={{ backgroundColor: "#e0f2f7" || 'white' }}>
      <a
        href={needHelpLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none', color: '#666' }}
      >
        <CardComponent
          title={t('MY_DEVICES.HEADER.HELP_TITLE')}
          description={t('MY_DEVICES.HEADER.HELP_DESCRIPTION')}
        />
      </a>
    </div>
  );
};

export { RecycleComponent, InspireComponent, ExploreComponent, NeedHelpComponent };
